import { useEffect, useMemo } from "react";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, FilterOptions } from "../../../../../../../_helpers/Helpers";
import * as actions from "../../../../_redux/user-assignment/UserAssignmentAction";
import { usePersonnelUsersUIContext } from "../PersonnelUsersUIContext";

const prepareFilter = (queryParams, values) => {
  let { tcKimlikNo, name, surname, personnelTypeId, userGroupId } = values;
  const newQueryParams = { ...queryParams };
  const filter = { tcKimlikNo, name, surname, personnelTypeId, userGroupId };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function PersonnelUsersFilter() {
  // Personnel Users UI Context
  const personnelUsersUIContext = usePersonnelUsersUIContext();
  const personnelUsersUIProps = useMemo(() => {
    return {
      setQueryParams: personnelUsersUIContext.setQueryParams,
      queryParams: personnelUsersUIContext.queryParams,
    };
  }, [personnelUsersUIContext]);

  const dispatch = useDispatch();
  const { personnelTypes, userGroups } = useSelector(
    (state) => ({
      personnelTypes: state.userAssignment.filters,
      userGroups: state.userAssignment.userGroups
    }),
    shallowEqual
  );
  
  useEffect(() => {
    dispatch(actions.getPersonnelTypes());
  }, [dispatch]);

  const applyFilter = (values) => {
    const newQueryParams = prepareFilter(personnelUsersUIProps.queryParams, values);
    if (!isEqual(newQueryParams, personnelUsersUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      personnelUsersUIProps.setQueryParams(newQueryParams);
    }
  };
  
  const personnelTypeOptions = FilterOptions.concat(personnelTypes);
  const userGroupOptions = FilterOptions.concat(userGroups);

  return (
    <Formik
      initialValues={{
        tcKimlikNo: "",
        name: "",
        surname: ""
      }}
      onSubmit={(values) => {
        applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="tcKimlikNo"
                placeholder="TC Kimlik No"
                onBlur={handleBlur}
                value={values.tcKimlikNo}
                onChange={(e) => {
                  setFieldValue("tcKimlikNo", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>TC Kimlik No</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Adı"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="surname"
                placeholder="Soyadı"
                onBlur={handleBlur}
                value={values.surname}
                onChange={(e) => {
                  setFieldValue("surname", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Soyadı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={personnelTypeOptions}
                value={values.personnelTypeId}
                placeholder="Personel Türü"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("personnelTypeId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Personel Türü</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={userGroupOptions}
                value={values.userGroupId}
                placeholder="Kullanıcı Grubu"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("userGroupId", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Kullanıcı Grubu</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}